'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, type FC, type PropsWithChildren, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { ShareRewardModal } from '@/shared/components/ShareRewardModal';
interface ShareReward {
  poe: number;
  coins: number;
  callback?: () => void;
}
interface ShareRewardContextType {
  showReward: (reward: ShareReward) => void;
  currentReward: ShareReward | null;
  isModalOpen: boolean;
  closeModal: () => void;
}
const ShareRewardContext = createContext<ShareRewardContextType | null>(null);
export const useShareReward = () => {
  const context = useContext(ShareRewardContext);
  if (!context) {
    throw new Error("useShareReward must be used within ShareRewardProvider");
  }
  return context;
};
export const ShareRewardProvider: FC<PropsWithChildren> = t0 => {
  const $ = _c(14);
  const {
    children
  } = t0;
  const [currentReward, setCurrentReward] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const timeoutRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = reward => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        if (reward.callback) {
          reward.callback();
        }
        setCurrentReward(reward);
        setIsModalOpen(true);
      }, 10000);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const showReward = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsModalOpen(false);
      setCurrentReward(null);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const closeModal = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
    t4 = [];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] !== currentReward || $[5] !== isModalOpen) {
    t5 = {
      showReward,
      currentReward,
      isModalOpen,
      closeModal
    };
    $[4] = currentReward;
    $[5] = isModalOpen;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== currentReward || $[8] !== isModalOpen) {
    t6 = currentReward && <ShareRewardModal isOpen={isModalOpen} onClose={closeModal} reward={currentReward} />;
    $[7] = currentReward;
    $[8] = isModalOpen;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== children || $[11] !== t5 || $[12] !== t6) {
    t7 = <ShareRewardContext.Provider value={t5}>{children}{t6}</ShareRewardContext.Provider>;
    $[10] = children;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};